interface OutlierLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function OutlierLogo({ className = '', size = 'md' }: OutlierLogoProps) {
  const sizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-3xl',
  };

  const dotSizes = {
    sm: 'w-1.5 h-1.5',
    md: 'w-2 h-2',
    lg: 'w-2.5 h-2.5',
  };

  return (
    <div className={`flex items-baseline ${className}`}>
      <span className={`font-bold tracking-tight text-[#F5F5F0] ${sizeClasses[size]}`}>
        Outlier
      </span>
      {/* Signal orange square period - aligned with text baseline */}
      <div
        className={`${dotSizes[size]} ml-0.5`}
        style={{ backgroundColor: '#FF6B35' }}
      />
    </div>
  );
}
